

import { AMC_INCIDENT_DETAILS_SET_VALUE } from "../../../actions/allSureMotorClaim/incidentDetails";
import { AMC_BASIC_DETAILS_SET_VALUE } from "../../../actions/allSureMotorClaim/basicDetails";
import { AMC_OTHER_DETAILS_SET_VALUE } from "../../../actions/allSureMotorClaim/otherDetails";
import { AMC_UPLOAD_DOCUMENTS_SET_VALUE } from "../../../actions/allSureMotorClaim/uploadDocuments";
import { incidentDetailsValidations } from "./incidentDetails";
import { basicDetailsValidation } from "./basicDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";
import { otherDetailsValidations } from "./otherDetails";

export const allSureMotorClaimValidation = (store, next, action) => {

  if(action.type.startsWith(AMC_BASIC_DETAILS_SET_VALUE)){
    return basicDetailsValidation(store, next, action)
  }
  if(action.type.startsWith(AMC_INCIDENT_DETAILS_SET_VALUE)){
    return incidentDetailsValidations(store, next, action)
  }
  if(action.type.startsWith(AMC_OTHER_DETAILS_SET_VALUE)){
    return otherDetailsValidations(store, next, action)
  }
  if(action.type.startsWith(AMC_UPLOAD_DOCUMENTS_SET_VALUE)){
    return uploadDocumentsValidation(store, next, action)
  }
  return null;
};
